@export struct PrintData {
  vertex: atomic<u32>,

  vector: atomic<u32>,
  vectors: array<vec4<f32>>,
};

